export const GET_ALL_GRUPOS_DE_ROTAS = 'GET_ALL_GRUPOS_DE_ROTAS'
export const GET_SPECIFIC_GRUPO_DE_ROTAS = 'GET_SPECIFIC_GRUPO_DE_ROTAS'
export const GET_GRUPO_DE_ROTAS_USE = 'GET_GRUPO_DE_ROTAS_USE'